module.exports = __webpack_public_path__ + "static/img/en_US3.9e53340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/en_US3.png
// module id = rnAk
// module chunks = 1